module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5OTUgOUMxMi41NTIgOSAxMyA4LjU1MjUgMTMgOFYxQzEzIDAuNDQ3NSAxMi41NTIgMCAxMS45OTk1IDBIMC45OTk1QzAuNDQ3IDAgMCAwLjQ0NzUgMCAxVjEzTDMuOTk5NSA5SDExLjk5OTVaIiBmaWxsPSIjRTRFQ0YzIi8+CjxwYXRoIGQ9Ik0xNC45OTk1IDJIMTRWMTBINC45OTk1MUwyLjk5OTUxIDEySDEyLjc5OTVMMTYgMTZWM0MxNiAyLjQ0NzUgMTYgMiAxNC45OTk1IDJaIiBmaWxsPSIjRTRFQ0YzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/community.svg
// module id = HVL6
// module chunks = 22